import styled from "styled-components";
import { colors } from "../../../../consts";

import { Paragraph2 } from "../../../Text/Paragraphs";
import { TextButton } from "../../../Buttons/styled";

export const DrapAndDropWrapper = styled.form`
  height: 160px;
  width: 100%;
  text-align: center;
  position: relative;

  #input-file-upload {
    display: none;
  }
`;

export const DragFileWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
`;

export const InputFileUploadLabel = styled.label`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 4px;
  border: 1.6px dashed;
  border-color: ${(props) =>
    props?.hasError ? colors.ERROR : props?.dragActive ? colors.RAISIN_100 : colors.RAISIN_50};

  background-color: ${(props) => (props?.dragActive ? "rgba(52, 48, 61, 0.2)" : colors.WHITE)};

  transition: background-color 0.2s ease-in;

  ${Paragraph2} {
    font-weight: 600;
  }

  ${TextButton} {
    text-decoration: underline;
  }
`;

export const SupportedFormatsInfo = styled(Paragraph2)`
  font-size: 14px;
  line-height: 26px;
  color: ${(props) => (props?.hasError ? colors.ERROR : colors.RAISIN_50)};
`;
